<template>
  <v-container fluid v-if="attendeesDetails">
    <material-card icon="mdi-google-classroom" title="Trainer Feedback Report">
      <a @click="$router.back()">
        <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back </v-btn>
        <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </a>
      <v-row>
        <v-col cols="3">Training Title : </v-col>
        <v-col cols="3">{{ attendeesDetails.training.title }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="3">Dates : </v-col>
        <v-col cols="3">From : {{ formatDate(attendeesDetails.training.fromDate) }}</v-col>
        <v-col cols="3">To : {{ formatDate(attendeesDetails.training.toDate) }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="3">Time : </v-col>
        <v-col cols="3">From : {{ attendeesDetails.training.fromTime }}</v-col>
        <v-col cols="3">To : {{ attendeesDetails.training.toTime }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="3">Trainer Name : </v-col>
        <v-col cols="3">{{attendeesDetails.trainerReport[0].trainerName ? attendeesDetails.trainerReport[0].trainerName.firstName + ' ' + attendeesDetails.trainerReport[0].trainerName.lastName : 'NA'}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="3">Attendance : </v-col>
        <v-col cols="3">{{ attendeesDetails.training.presentTeacherCount + '/' + attendeesDetails.training.enrolledTeacherCount }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="3">Average score : </v-col>
        <v-col v-if="attendeesDetails.training.averageScore === null " cols="3">{{ 0 + '%'}}</v-col>
        <v-col v-else cols="3">{{ attendeesDetails.training.averageScore + '%'}}</v-col>
      </v-row>
      <v-row v-for="(questionList, i) in attendeesDetails.questionsAverage" :key="i">
        <v-col cols="3">{{ questionList.question }} </v-col>
        <v-col cols="3">{{ Math.round(questionList.averageScore) + '/' + Math.round(questionList.totalScore) }}</v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="3">Trainer remarks : </v-col>
        <v-col cols="3" v-for="(remark, index) in trainerRemark" :key="index">
          <v-textarea outlined :value="remark.trainerRemark" readonly></v-textarea>
        </v-col>
        <v-btn v-if="trainerRemarkCount > trainerRemark.length" @click="getTrainerRemarkDetails(true)">LOAD MORE</v-btn>
      </v-row>
      <v-row>
        <v-col cols="3">Any other comment/Content remark : </v-col>
        <v-col cols="3" v-for="(remark, index) in contentRemark" :key="index">
          <v-textarea outlined :value="remark.contentRemark" readonly></v-textarea>
        </v-col>
        <v-btn v-if="contentRemarkCount > contentRemark.length" @click="getContentRemarkDetails(true)">LOAD MORE</v-btn>
      </v-row>
    </material-card>
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import moment from 'moment'
export default {
  name: 'indiviualTrainerFeedbackReport',
  props: {
    trainingID: String,
    trainerID: String
  },
  components: {
    MaterialCard
  },

  data () {
    return {
      trainingByTrainers: null,
      trainingType: '',
      registeredClasses: [],
      franchiseeIDs: [],
      selectedStaff: [],
      previousSelectedStaff: [],
      teachersData: [],
      feedbackQuestions: null,
      attendeesDetails: null,
      length: 2,
      contentRemark: [],
      trainerRemark: [],
      contentRemarkPage: 0,
      trainerRemarkPage: 0,
      trainerRemarkCount: 0,
      contentRemarkCount: 0
    }
  },
  created: function () {
    this.getAttendeesDetails()
    this.getTrainerRemarkDetails()
    this.getContentRemarkDetails()
  },
  methods: {
    getAttendeesDetails: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/teacher-training/feedback/trainer-report/${this.trainingID}/${this.trainerID}`)
        this.attendeesDetails = data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    getTrainerRemarkDetails: async function (OnClickLoadMore = false) {
      try {
        if (OnClickLoadMore === true) {
          this.trainerRemarkPage = this.trainerRemarkPage + 1
        }
        const { data } = await http.post(`${constants.API_URL}/api/teacher-training/feedback/content`, {
          trainingId: this.trainingID,
          type: 'trainerRemark',
          trainerId: this.trainerID,
          page: this.trainerRemarkPage,
          size: 2
        })
        this.trainerRemarkCount = data.count
        this.trainerRemark = data.rows.concat(this.trainerRemark)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    getContentRemarkDetails: async function (OnClickLoadMore = false) {
      try {
        if (OnClickLoadMore === true) {
          this.contentRemarkPage = this.contentRemarkPage + 1
        }
        const { data } = await http.post(`${constants.API_URL}/api/teacher-training/feedback/content`, {
          trainingId: this.trainingID,
          type: 'contentRemark',
          trainerId: this.trainerID,
          page: this.contentRemarkPage,
          size: 2
        })
        this.contentRemarkCount = data.count

        this.contentRemark = data.rows.concat(this.contentRemark)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },

    formatDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },

    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
#abcd {
  color: rgba(0, 0, 0, 0.6);
  font-size: 16px;
}
</style>
